import React from 'react';
import { Car, Award, Users } from 'lucide-react';
const TrustBadges = () => {
  return <section className="bg-gray-50 py-16" data-id="element-369" data-mp="2oihwpl6z972p">
      <div className="container mx-auto px-4" data-id="element-370" data-mp="2ojswl9xaxuoj">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-371" data-mp="32hrake7pnp3i">
          {/* Modern Automatic Vehicles */}
          <div className="flex flex-col items-center text-center" data-id="element-372" data-mp="2xieovwskso2i">
            <div className="bg-blue-100 p-6 rounded-full mb-4" data-id="element-373" data-mp="2xl985kzus2uc">
              <Car size={32} className="text-blue-600" data-id="element-374" data-mp="3cevwqe1k3kkb" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-375" data-mp="37hvt09s6itwd">
              Modern Automatic Vehicles
            </h3>
            <p className="text-gray-700" data-id="element-376" data-mp="3l7focujfkovn">
              Learn in our dual-controlled, air-conditioned automatic vehicles
              equipped with the latest safety features.
            </p>
          </div>
          {/* Qualified Instructors */}
          <div className="flex flex-col items-center text-center" data-id="element-377" data-mp="3v4c0rbcg9v5h">
            <div className="bg-blue-100 p-6 rounded-full mb-4" data-id="element-378" data-mp="3q952ij1y9iny">
              <Award size={32} className="text-blue-600" data-id="element-379" data-mp="2psppfd4xmvxc" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-380" data-mp="2ur9fnpqk6tvi">Qualified Instructors</h3>
            <p className="text-gray-700" data-id="element-381" data-mp="2utdgfyt5vcrk">
              All our instructors are DVSA approved with years of experience and
              excellent pass rates.
            </p>
          </div>
          {/* Personalized Lessons */}
          <div className="flex flex-col items-center text-center" data-id="element-382" data-mp="38rbt8zru314y">
            <div className="bg-blue-100 p-6 rounded-full mb-4" data-id="element-383" data-mp="38oy0ixkmm10k">
              <Users size={32} className="text-blue-600" data-id="element-384" data-mp="3dp3mpy84mvb9" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-385" data-mp="3igbvcs1mucnd">Personalised Lessons</h3>
            <p className="text-gray-700" data-id="element-386" data-mp="3nfyjvxmwvfbh">
              We tailor our teaching methods to suit your learning style and
              help you progress at your own pace.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default TrustBadges;